var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 227,
    height: 41,
    viewBox: "0 0 227 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.773519 40.0206L0 39.2511V1.75423L0.773519 0.980705H8.66694L9.44046 1.75423V23.97H25.867V1.75423L26.6405 0.980705H34.5339L35.3074 1.75423V39.2511L34.5339 40.0246H26.6405L25.867 39.2511V24.8206H9.44046V39.2511L8.66694 40.0246H0.773519V40.0206Z",
    fill: "#807CE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5079 0.980705H84.0809L91.7079 15.541L99.3349 0.980705H108.855L109.629 1.75423L96.4559 22.5541V39.2511L95.6296 40.0246H87.7862L87.0127 39.2511V22.5541L73.7871 1.75423L74.5079 0.980705Z",
    fill: "#807CE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.884 40.0206H114.137L113.363 39.2471V1.75423L114.137 0.980705H130.884C141.683 0.980705 148.164 9.19465 148.164 20.5013C148.164 31.835 141.604 40.0219 130.884 40.0219V40.0206ZM122.804 32.6072H126.751C133.311 32.6072 138.697 29.1399 138.697 20.5C138.697 11.86 133.07 8.39272 126.751 8.39272H122.805V32.6058L122.804 32.6072Z",
    fill: "#807CE0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.494 20.5264C151.494 9.03174 158.054 0.5 169.948 0.5C181.841 0.5 188.401 8.98035 188.401 20.5264C188.401 32.0724 181.789 40.5 169.948 40.5C158.107 40.5 151.494 31.9669 151.494 20.5264ZM169.975 33.0866C175.361 33.0866 178.988 28.9526 178.988 20.5264C178.988 12.1001 175.607 7.91336 169.975 7.91336C164.342 7.91336 160.962 12.207 160.962 20.5264C160.962 28.8458 164.341 33.0907 169.975 33.0907V33.0866Z",
    fill: "#807CE0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M217.681 39.2511L202.374 6.50353V39.2511L201.6 40.0246H193.757L192.931 39.2511V1.75423L193.757 0.980705H200.371L201.197 1.75423L216.825 34.9548V1.75423L217.598 0.980705H225.492L226.265 1.75423V39.2511L225.492 40.0246H218.451L217.678 39.2511H217.681Z",
    fill: "#807CE0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5865 23.9699L58.853 12.6903L63.1736 23.9699H54.5865ZM54.266 24.8232L48.827 39.251L48.0535 40.0246H39.8936L39.1201 39.251L54.7203 1.5973L55.6007 0.983345H62.2135L63.0938 1.5973L78.7198 39.251L77.9463 40.0246H69.7864L69.0129 39.251L63.4928 24.8246L54.266 24.8232Z",
    fill: "#807CE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/login-logo.edf421e7211ae834dbd61778c0c0dc07.svg";
export { ForwardRef as ReactComponent };